import { ChatBtn } from "../chat-btn";
import { DescriptionSection } from "./description";
import { HeroSection } from "./hero";

export function StagesPage() {
  return (
    <main class="relative w-full h-full ">
      <HeroSection />
      <DescriptionSection />
      <ChatBtn />
    </main>
  );
}
